import ReactDatePicker from 'react-datepicker'
import { getYear, getMonth } from '../../utils/date-service'

import 'react-datepicker/dist/react-datepicker.css'

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export default function DatePicker(props) {
  return (
    <>
      <ReactDatePicker
        formatWeekDay={(nameOfDay) => nameOfDay.substr(0, 1)}
        dateFormat='MM/dd/yyyy'
        renderCustomHeader={({
          date,
          changeYear,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
          prevYearButtonDisabled,
          nextYearButtonDisabled,
        }) => (
          <div className='datePickerHeader flex alignCenter justifyBetween'>
            <button
              aria-label='previous year'
              className='flatBtn prevYear'
              disabled={prevYearButtonDisabled}
              onClick={() => changeYear(getYear(date) - 1)}
            >
              &lt;&lt;
            </button>
            <button
              aria-label='previous month'
              className='flatBtn prevMonth'
              disabled={prevMonthButtonDisabled}
              onClick={decreaseMonth}
            >
              &lt;
            </button>
            <div className='dateText flex justifyCenter'>
              <span className='month'>{months[getMonth(date)]}</span>
              <span className='year'>{getYear(date)}</span>
            </div>
            <button
              aria-label='next month'
              className='flatBtn nextMonth'
              disabled={nextMonthButtonDisabled}
              onClick={increaseMonth}
            >
              &gt;
            </button>
            <button
              aria-label='next year'
              className='flatBtn nextYear'
              disabled={nextYearButtonDisabled}
              onClick={() => changeYear(getYear(date) + 1)}
            >
              &gt;&gt;
            </button>
          </div>
        )}
        {...props}
      />

      <style jsx global>{`
        .react-datepicker {
          max-width: 42rem;
          min-width: 26rem;
          width: auto;
          padding: 1rem;
          border: 0;
          border-radius: 0;
          background: #fff;
          font: inherit;
          color: #000;
        }

        .react-datepicker__month-container {
          width: 100%;
        }

        .react-datepicker__day-names {
          display: flex;
          justify-content: space-between;
          padding: 1.5rem 0 0.6rem;
          border-bottom: 0.1rem solid #e9ecf2;
          color: var(--secondary-text-color);
          font-weight: 700;
        }

        .react-datepicker__week {
          display: flex;
          justify-content: space-between;
          padding: 1.4rem 0 0.65rem;
          border-bottom: 0.1rem solid #e9ecf2;
        }

        .react-datepicker__day-name,
        .react-datepicker__day {
          width: 2.5rem;
          text-align: center;
          font-size: 1.6rem;
          color: #000;
        }

        .react-datepicker__day {
          cursor: pointer;
        }

        .react-datepicker__day--selected {
          border-radius: 0.5rem;
          background: var(--primary-button-bg);
          color: #fff;
          font-weight: 700;
        }

        .react-datepicker__day--outside-month {
          color: var(--secondary-text-color);
        }

        .react-datepicker__day--disabled {
          cursor: not-allowed;
          color: var(--secondary-text-color);
        }

        .datePickerHeader {
          font-weight: 700;
          font-size: 1.6rem;
        }

        .datePickerHeader .dateText {
          width: 14.1rem;
        }

        .datePickerHeader .prevMonth,
        .datePickerHeader .nextMonth {
          width: unset;
        }

        .datePickerHeader .prevYear,
        .datePickerHeader .prevMonth {
          text-align: left;
        }

        .datePickerHeader .nextYear,
        .datePickerHeader .nextMonth {
          text-align: right;
        }

        .datePickerHeader .month,
        .datePickerHeader .year {
          display: inline-block;
          margin: 0 0.5rem;
        }

        .react-datepicker-popper {
          z-index: 10;
        }
      `}</style>
    </>
  )
}
